import { render } from "./newsList.vue?vue&type=template&id=89339eec&scoped=true&ts=true"
import script from "./newsList.vue?vue&type=script&lang=ts&config=true"
export * from "./newsList.vue?vue&type=script&lang=ts&config=true"

import "./newsList.vue?vue&type=style&index=0&id=89339eec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89339eec"]])

export default __exports__